// extracted by mini-css-extract-plugin
export var typingIndicator = "_n4-0";